import {
    Component,
    OnInit,
    ViewChild,
    ElementRef,
    OnDestroy,
    HostListener,
    AfterViewInit,
    Inject,
    PLATFORM_ID
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { FormGroup, FormControl } from '@angular/forms';
import { MainBodyService } from '../../services/main-body.service';
import { EnvService } from '../../services/env.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { LanguagesService } from '../../services/languages.service';
import { PublisherService } from '../../services/publisher.service';
import { TranslateService } from '@ngx-translate/core';
import { Listlang, listresponse } from 'src/interface/lang';
import {
    journalData,
    journalPagesData,
    mediaLink,
    responsedata,
    themeData,
} from 'src/interface/themesetting';
import { CartService } from '../../services/cart.service';
import { SharedService } from '../../services/shared.service';
import { catchError, debounceTime, filter, map, of, Subject, Subscription, switchMap } from 'rxjs';
import {
    commonSearch,
    listAllarticle,
    listArticle,
    searchData,
} from 'src/interface/article';
import { GetArticlesService } from '../../services/get-articles.service';
import { JournalService } from '../../journal/journal.service';
import { Book, JournalType } from 'src/interface/book';
// import { BookService } from 'src/app/book/book.service';
import { VolumeService } from 'src/app/services/volume.service';
import { volume } from 'src/interface/volumeIssue';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoginComponent } from '../../user/login/login.component';
import {
    contentData1,
    contentDataJBA,
    journalPageResponce,
} from 'src/interface/contentGet';
import { UserService } from 'src/app/user/user.service';
import { UniversalStorageService } from '../../services/universal-storage.service';

@Component({
    selector: 'app-header',
    templateUrl: './app-header.component.html',
    styleUrls: ['./app-header.component.scss'],
})
export class AppHeaderComponent implements OnInit, OnDestroy, AfterViewInit {
    @ViewChild('navToggle') navToggle: ElementRef | undefined;
    // @ViewChild('hideNavOnScroll');
    @ViewChild('offcanvasNavbar') offcanvasNavbar: ElementRef;
    hideNavOnScroll!: ElementRef<HTMLButtonElement>;
    dropdownExpanded = false;
    searchBoxActive = false;
    activeLanguages: Listlang[];
    itemsInCart = 0;
    toggleStatus = false;
    themeSettingsData: themeData;
    journalSettingData: themeData;
    dynamicMenuData: contentData1[] = [];
    journalDynamicData: contentData1[] = [];
    secondNavigation = false;
    yourTranslatedObservableText: string;
    langSelectMenu: FormGroup;
    currentLocalLanguage: string;
    currentCountryCode = 'gb';
    // popupResponciveVariable = false;
    secondNavigationBook = false;
    themePath = '';
    journalId: string;
    defaultPublisherLogo = '';
    defaultJournalLogo = '';
    dynamic_menus: contentData1[] = [];
    socialmediaicon = false;
    // dynamic_menus_journal: contentData1[] = [];
    //for Jba
    dynamic_menus_journal: contentDataJBA[] = [];
    dynamic_menus_author: any[] = [];
    secondaryTextcolor = '';
    secondaryBackground = '';
    public searchForm: FormGroup;
    public searchData: { searchValue: FormControl };
    searchLoader = false;
    private searchSubject = new Subject<string>();
    private searchTerm: string | null = null;
    private readonly minSearchLength = 3;
    searchedArticles: searchData[] = [];
    public valueForSearch = '';
    queryParams: commonSearch;
    dataToBeDisplay = 3;
    startArticle = 0;
    volume_id = '';
    issue_id = '';
    temp_page_count: number;
    tempSearchArticles: searchData[] = [];
    journalTitle = '';
    journal_id: string;
    journalIdLoaded: boolean;
    journal_id_jba: string;
    is_exist_about = false;
    is_exist_access = false;
    is_exist_about_journal = false;
    is_exist_home_journal = false;
    journalData: journalData[] = [];
    journalCurrentData: journalData[] = [];
    journalRetiredData: journalData[] = [];
    books_value: Book[] = [];
    volumeSub: Subscription;
    volumeData: volume[] = [];
    public articleList: listArticle[] = [];
    fastTrackList: listArticle[] = [];
    islogined: boolean;
    loggedInUsername: string | null = null;
    subscription: Subscription[] = [];
    user_email: string;
    user_name: string;
    profile_picture: string;
    fullName: string;
    navprimarycolor: string;
    contactStatus: boolean;
    journal_name: string;
    dynamic_menu_journal_status: boolean;
    journalPagesData: journalPagesData[] = [];
    aboutPageId: string;
    homePageId: string;
    publisherLogo: string;
    imis_id: string;
    publisher_id: string;
    about_url: string;
    about_name: string;
    clustered_url: string;
    clustered_name: string;
    inst_authors_url: string;
    inst_authors_name: string;
    inst_guest_url: string;
    inst_guest_name: string;
    sub_info_url: string;
    sub_info_name: string;
    permission_url: string;
    permission_name: string;
    pre_your_art_url: string;
    pre_your_art_name; string;
    ref_url: string;
    ref_name: string;
    rss_url: string;
    temporary_value = false;//flag for disabling section for JBA
    client_name_label: string;
    application_mode_label: string;
    searchList = false;
    loading = true;
    noData = false;
    loading_image = true;
    showSearchBarTextBox = false;
    ShowSearchUl = false;
    isSmallScreen: boolean;
    about_isCollapsed = false;
    article_isCollapsed = false;
    submit_article_isCollapsed = false;
    accoutWishCart = false;
    art_sub_name = '';
    art_sub_url = '';
    promo_art_name = '';
    promo_art_url = '';
    prod_art_name = '';
    prod_art_url = '';
    inf_pol_name = '';
    inf_pol_url = '';
    dynamic_menu_loader = true;
    constructor(
        private mainBodyService: MainBodyService,
        private EnvService: EnvService,
        private route: ActivatedRoute,
        private router: Router,
        private langService: LanguagesService,
        private translateService: TranslateService,
        private cartService: CartService,
        private sharedService: SharedService,
        private articleService: GetArticlesService,
        private journalService: JournalService,
        // private bookService: BookService,
        private volumeService: VolumeService,
        private modalService: NgbModal,
        private userService: UserService,
        private storageService: UniversalStorageService,
        private publisherService: PublisherService,
        @Inject(PLATFORM_ID) private platformId: any
    ) {
        if (isPlatformBrowser(this.platformId)) {
            this.isSmallScreen = window.innerWidth < 992;
            router.events.subscribe((e) => {

                let currentRoute = this.route.root;
                while (currentRoute.children[0] !== undefined) {
                    currentRoute = currentRoute.children[0];
                    this.storageService.getItem('BEARER_TOKEN');
                }
                if (e instanceof NavigationEnd) {
                    // you can do it for exact phase
                    // const journal = currentRoute.snapshot.params;

                    // this.journalId = journal['journal_id'];
                    const journalType: JournalType = { jnl_type: '' };
                    this.journalService
                        .getJournals(journalType)
                        .subscribe((result) => {
                            this.journalData = result.data;
                            this.journalId = this.journalData[0].id;
                            this.sharedService.setJournalId(this.journalId);
                            this.mainBodyService
                                .getAllThemeSettings(this.journalId)
                                .subscribe((result: responsedata) => {

                                    if (result.status === 200) {
                                        this.loading = false;
                                        this.loading_image = false;
                                        this.journalSettingData = result.data;
                                        this.returnSocialMedia(this.journalSettingData);
                                        const color = this.journalSettingData.theme_colors;
                                        if (isPlatformBrowser(this.platformId)) {
                                            Object.entries(color).map(
                                                ([key, value]) => {
                                                    const element = '--' + key;
                                                    const val: string = value;
                                                    document.documentElement.style.setProperty(
                                                        element,
                                                        val
                                                    );
                                                }
                                            );
                                        }
                                    } else {
                                        this.journalSettingData = result.data;
                                        this.returnSocialMedia(this.journalSettingData);
                                    }
                                });
                        });
                }
            });

            const token = this.storageService.getItem('BEARER_TOKEN'); // Replace with your token storage mechanism
            if (token) {
                const tokenPayload = this.decodeToken(token);
                this.user_email = tokenPayload.data.email;
                this.user_name = tokenPayload.data.user_name;
                this.imis_id = tokenPayload.data.imis_id;
                this.getProfilePictiure();
            }
        }

    }

    ngOnInit(): void {
        // this.elementRef.nativeElement.ownerDocument.addEventListener('click', this.onGlobalClick.bind(this));
        this.searchForm = new FormGroup({
            searchValue: new FormControl(),
        });
        this.searchData = {
            searchValue: this.searchForm.controls['searchValue'] as FormControl,
        };

        this.client_name_label = this.EnvService.clientName;
        this.application_mode_label = this.EnvService.applicationMode;
        this.rss_url = this.EnvService.rssFeed;
        const journalType: JournalType = { jnl_type: '' };
        const journalSub = this.journalService
            .getJournals(journalType)
            .subscribe((result) => {
                this.journalData = result.data;
                this.journal_id_jba = this.journalData[0].id;
                this.getDynamicMenusJournal(this.journal_id_jba);

                // Every input change (typing, backspace, clearing) goes through here. Short/empty
                // terms still pass through switchMap so any in-flight request is cancelled, and each
                // response carries the term it was requested for, so stale results are dropped.
                const searchSub = this.searchSubject
                    .pipe(
                        debounceTime(1000),
                        switchMap((term: string) => term.length < this.minSearchLength
                            ? of({ term, result: null, skipped: true })
                            : this.articleService.commonSearch({ search_key: term }).pipe(
                                map(result => ({ term, result, skipped: false })),
                                catchError(() => of({ term, result: null, skipped: false }))
                            )
                        )
                    )
                    .subscribe(({ term, result, skipped }) => {
                        if (skipped || term !== this.searchTerm) {
                            return;
                        }
                        this.searchLoader = false;
                        this.loading = false;
                        if (!result) {
                            // Request failed: don't claim there is no matching data.
                            return;
                        }
                        if (result.data?.['articles']?.length > 0) {
                            this.searchedArticles = result.data;
                        }
                        else {
                            this.noData = true;
                        }
                    });
                this.subscription.push(searchSub);
                this.publisherService.fetchPublisherId().subscribe(response => {
                    this.publisher_id = response[0].publisher_id;
                    this.route.params.subscribe((params) => {

                        this.journalId = params['journal_id'] || this.publisher_id;
                    });
                    this.loadThemeSettings();
                    const sharedSub = this.sharedService
                        .getUsername()
                        .subscribe((username) => {
                            this.loggedInUsername = username;
                            this.islogined = true;
                        });
                    this.subscription.push(sharedSub);
                    const storedUsername = this.storageService.getItem('loggedInUsername');
                    if (storedUsername) {
                        this.loggedInUsername = storedUsername;
                    } else {
                        this.islogined = false;
                    }

                    this.defaultPublisherLogo =
                        this.EnvService.defaultImagePath +
                        this.EnvService.default_publisherLogo;
                    this.defaultJournalLogo =
                        this.EnvService.defaultImagePath +
                        this.EnvService.default_journalLogo;


                    this.themePath = this.EnvService.imageUrl + 'themes/';
                    this.currentLocalLanguage = this.storageService.getItem(
                        'language'
                    ) as string;
                    const cartSub = this.cartService.itemsInCart$.subscribe((count) => {
                        this.itemsInCart = Math.min(count, 15);
                    });
                    this.subscription.push(cartSub);
                    const themeSub = this.mainBodyService
                        .getAllThemeSettings(this.publisher_id)
                        .subscribe((result: responsedata) => {
                            if (result.status === 200) {
                                this.themeSettingsData = result.data;
                                this.navprimarycolor =
                                    result.data.theme_colors.primary_color;
                                this.publisherLogo = this.themeSettingsData.journal_logo
                                    ? this.EnvService.imageUrl +
                                    'themes/' +
                                    this.themeSettingsData.journal_logo
                                    : this.defaultPublisherLogo;
                                // const dynamicMenuSub = this.mainBodyService
                                //     .getAllDynamicMenus(this.publisher_id)
                                //     .subscribe((result: journalPageResponce) => {
                                //         if (result.status === 200) {
                                //             this.processMenuData(result);
                                //             this.dynamicMenuData = this.journalPagesData;
                                //         }
                                //     });
                                // this.subscription.push(dynamicMenuSub);
                                //for JBA
                                if (this.journal_id_jba) {
                                    const dynamicMenuSubJBA = this.mainBodyService
                                        .getAllDynamicMenus(this.journal_id_jba)
                                        .subscribe((result: journalPageResponce) => {
                                            if (result.status === 200) {
                                                this.processMenuData(result);

                                                const aboutPage = this.journalPagesData.find(item => item.pageName === 'About' && item.status == true);
                                                if (aboutPage) {
                                                    this.about_url = '/content/' + aboutPage.page_identifier
                                                    this.dynamicMenuData = this.journalPagesData;
                                                    this.about_name = aboutPage.pageName;
                                                }
                                                // const clusteredPage = this.journalPagesData.find(item => item.pageName === 'Clustered themes');
                                                // if (clusteredPage) {
                                                //     this.clustered_url = '/content/' + clusteredPage.pageId
                                                //     this.dynamicMenuData = this.journalPagesData;
                                                //     this.clustered_name = clusteredPage.pageName;
                                                // }
                                                const art_sub = this.journalPagesData.find(item => item.page_identifier === 'article-submission');
                                                if (art_sub) {
                                                    this.art_sub_url = '/content/' + art_sub.page_identifier
                                                    this.dynamicMenuData = this.journalPagesData;
                                                    this.art_sub_name = art_sub.pageName;
                                                }
                                                const inst_authors = this.journalPagesData.find(item => item.page_identifier === 'instructions-for-authors');
                                                if (inst_authors) {
                                                    this.inst_authors_url = '/content/' + inst_authors.page_identifier
                                                    this.dynamicMenuData = this.journalPagesData;
                                                    this.inst_authors_name = inst_authors.pageName;
                                                }
                                                const inst_guest = this.journalPagesData.find(item => item.page_identifier === 'information-for-guest-editors');
                                                if (inst_guest) {
                                                    this.inst_guest_url = '/content/' + inst_guest.page_identifier
                                                    this.dynamicMenuData = this.journalPagesData;
                                                    this.inst_guest_name = inst_guest.pageName;
                                                }
                                                const prod_art = this.journalPagesData.find(item => item.page_identifier === 'production-of-your-article');
                                                if (prod_art) {
                                                    this.prod_art_url = '/content/' + prod_art.page_identifier
                                                    this.dynamicMenuData = this.journalPagesData;
                                                    this.prod_art_name = prod_art.pageName;
                                                }
                                                const promo_art = this.journalPagesData.find(item => item.page_identifier === 'promoting-your-article');
                                                if (promo_art) {
                                                    this.promo_art_url = '/content/' + promo_art.page_identifier
                                                    this.dynamicMenuData = this.journalPagesData;
                                                    this.promo_art_name = promo_art.pageName;
                                                }
                                                const inf_pol = this.journalPagesData.find(item => item.page_identifier === 'influencing-policy-makers');
                                                if (inf_pol) {
                                                    this.inf_pol_url = '/content/' + inf_pol.page_identifier
                                                    this.dynamicMenuData = this.journalPagesData;
                                                    this.inf_pol_name = inf_pol.pageName;
                                                }
                                                // const sub_info = this.journalPagesData.find(item => item.pageName === 'Submission Information');
                                                // if (sub_info) {
                                                //     this.sub_info_url = '/content/' + sub_info.pageId
                                                //     this.dynamicMenuData = this.journalPagesData;
                                                //     this.sub_info_name = sub_info.pageName;
                                                // }
                                                // item.page_identifier !== 'influencing-policy-makers'&&
                                                // item.page_identifier !== 'production-of-your-article'&&
                                                // item.page_identifier !== 'promoting-your-article'&&
                                                // item.page_identifier !== 'article-submission'
                                                const pre_your_art = this.journalPagesData.find(item => item.pageName === 'Preparing your article');
                                                if (pre_your_art) {
                                                    this.pre_your_art_url = '/content/' + pre_your_art.page_identifier
                                                    this.dynamicMenuData = this.journalPagesData;
                                                    this.pre_your_art_name = pre_your_art.pageName;
                                                }
                                                // const ref = this.journalPagesData.find(item => item.pageName === 'References'&& item.status==true);
                                                // if (ref) {
                                                //     this.ref_url = '/content/' + ref.pageId
                                                //     this.dynamicMenuData = this.journalPagesData;
                                                //     this.ref_name = ref.pageName;
                                                // }
                                            }
                                        });
                                    this.subscription.push(dynamicMenuSubJBA);
                                }
                                const journalCType: JournalType = { jnl_type: 'CPC' };
                                const journals = this.journalService
                                    .getJournals(journalCType)
                                    .subscribe((result) => {
                                        this.journalCurrentData = result.data;
                                    });
                                this.subscription.push(journals);
                                const journalRType: JournalType = { jnl_type: 'CPR' };
                                const journal = this.journalService
                                    .getJournals(journalRType)
                                    .subscribe((result) => {
                                        this.journalRetiredData = result.data;
                                    });
                                this.subscription.push(journal);
                                const journalType: JournalType = { jnl_type: 'JNL' };
                                const journalSub = this.journalService
                                    .getJournals(journalType)
                                    .subscribe((result) => {
                                        this.journalData = result.data;
                                    });
                                this.subscription.push(journalSub);
                                // const listData: bookList = {
                                //     search_key: '',
                                //     length: '10',
                                //     start: '0',
                                //     filter: 'new_release',
                                // };
                                // const bookSub = this.bookService
                                //     .getBookDetails(listData)
                                //     .subscribe((data) => {
                                //         this.books_value = data.data;
                                //     });
                                // this.subscription.push(bookSub);
                            }
                            const color = this.themeSettingsData?.theme_colors;
                            if (isPlatformBrowser(this.platformId)) {
                                Object.entries(color).map(([key, value]) => {
                                    const element = '--Pub' + key;
                                    const val = value;
                                    document.documentElement.style.setProperty(element, val);
                                });
                            }
                        });
                    this.subscription.push(themeSub);
                    this.currentLocalLanguage = this.storageService.getItem(
                        'language'
                    ) as string;
                    const translateSub = this.translateService
                        .get('app_header.header_information.string')
                        .subscribe((translatedString) => {
                            this.yourTranslatedObservableText = translatedString;
                        });
                    this.subscription.push(translateSub);
                    const dynamicMenuSub = this.mainBodyService
                        .getAllDynamicMenus(this.publisher_id)
                        .subscribe((result: journalPageResponce) => {
                            this.dynamicMenuData = [];
                            if (result.status === 200) {
                                this.processMenuData(result);

                                this.dynamicMenuData = this.journalPagesData;
                            }
                        });
                    this.subscription.push(dynamicMenuSub);
                    const languageSub = this.langService
                        .getActiveLang()
                        .subscribe((result: listresponse) => {
                            if (
                                result &&
                                result.status === 200 &&
                                result.data &&
                                result.data.length > 0
                            ) {
                                this.activeLanguages = result.data;
                                this.storageService.setItem(
                                    'language',
                                    result.data[0].country_language_code
                                );
                            }
                        });
                    this.subscription.push(languageSub);
                    const routeSub = this.route.params.subscribe((params) => {
                        params['jnlid'] !== undefined
                            ? (this.secondNavigation = true)
                            : (this.secondNavigation = false);
                    });
                    this.subscription.push(routeSub);
                    const navigationSub = this.mainBodyService.secondNavigation.subscribe(
                        (data: boolean) => {
                            this.secondNavigation = data;
                            this.secondNavigationBook = false;
                            if (this.secondNavigationBook === false) {

                                let journal_id: string[] = [];
                                journal_id = this.router.url.split('/');

                                if (journal_id[2]) {
                                    const themeSub = this.mainBodyService
                                        .getAllThemeSettings(journal_id[2])
                                        .subscribe((result: responsedata) => {
                                            if (result.status === 200) {
                                                this.journalSettingData = result.data;


                                                this.returnSocialMedia(this.journalSettingData);
                                                const color = this.themeSettingsData.theme_colors;
                                                if (isPlatformBrowser(this.platformId)) {
                                                    Object.entries(color).map(
                                                        ([key, value]) => {
                                                            const element = '--' + key;
                                                            const val: string = value;
                                                            document.documentElement.style.setProperty(
                                                                element,
                                                                val
                                                            );
                                                        }
                                                    );
                                                }
                                            } else {
                                                this.journalSettingData = result.data;


                                                this.returnSocialMedia(this.journalSettingData);
                                            }
                                        });
                                    this.toFetchJournalMenuData(journal_id[2]);
                                    this.subscription.push(themeSub);

                                    this.returnSocialMedia(this.journalSettingData);
                                }

                                this.returnSocialMedia(this.journalSettingData);
                            }
                            else {

                                this.returnSocialMedia(this.journalSettingData);
                            }
                            //for  getting social icons in JBA
                            if (this.journal_id_jba) {
                                const themeSub = this.mainBodyService
                                    .getAllThemeSettings(this.journal_id_jba)
                                    .subscribe((result: responsedata) => {
                                        if (result.status === 200) {
                                            this.journalSettingData = result.data;

                                            const color = this.themeSettingsData.theme_colors;
                                            if (isPlatformBrowser(this.platformId)) {
                                                Object.entries(color).map(
                                                    ([key, value]) => {
                                                        const element = '--' + key;
                                                        const val: string = value;
                                                        document.documentElement.style.setProperty(
                                                            element,
                                                            val
                                                        );
                                                    }
                                                );
                                            }
                                        } else {
                                            this.journalSettingData = result.data;

                                            this.returnSocialMedia(this.journalSettingData);

                                        }
                                    });
                                this.toFetchJournalMenuData(this.journal_id_jba);
                                this.subscription.push(themeSub);
                                const themeSub1 = this.mainBodyService
                                    .getAllThemeSettings(this.journal_id_jba)
                                    .subscribe((result: responsedata) => {
                                        if (result.status === 200) {
                                            this.journalSettingData = result.data;

                                            this.returnSocialMedia(this.journalSettingData);
                                            const color = this.themeSettingsData.theme_colors;
                                            if (isPlatformBrowser(this.platformId)) {
                                                Object.entries(color).map(
                                                    ([key, value]) => {
                                                        const element = '--' + key;
                                                        const val: string = value;
                                                        document.documentElement.style.setProperty(
                                                            element,
                                                            val
                                                        );
                                                    }
                                                );
                                            }
                                        } else {
                                            this.journalSettingData = result.data;

                                            this.returnSocialMedia(this.journalSettingData);
                                        }
                                    });
                                this.subscription.push(themeSub1);
                            }
                            else {

                                this.returnSocialMedia(this.journalSettingData);
                            }
                            //ending for getting social icons in JBA
                            const jnlid =
                                this.route.snapshot['_routerState'].url.split('/');
                            if (jnlid) {
                                const journalType: JournalType = { jnl_type: 'JNL' };
                                const journalSub = this.journalService
                                    .getJournals(journalType)
                                    .subscribe((res) => {
                                        if (res) {
                                            for (let i = 0; i < res.data.length; i++) {
                                                if (res.data[i].id === jnlid[1]) {
                                                    this.journalTitle =
                                                        res.data[i].journal_title;
                                                    break;
                                                }
                                            }
                                        }
                                    });
                                this.subscription.push(journalSub);
                            }
                        }
                    );
                    this.subscription.push(navigationSub);
                    const navigationSub1 =
                        this.mainBodyService.secondNavigationBook.subscribe(
                            (data: boolean) => {
                                this.secondNavigationBook = data;


                                this.returnSocialMedia(this.journalSettingData);
                                this.secondNavigation = data;
                            }
                        );
                    this.subscription.push(navigationSub1);
                });
            });
        this.subscription.push(journalSub);
    }
    // onGlobalClick(event: MouseEvent) {
    //     // Check if the clicked element is outside the offcanvas navbar
    //     if (!this.offcanvasNavbar.nativeElement.contains(event.target)) {
    //       // Close the offcanvas navbar here
    //       // You can implement your logic to close the offcanvas navbar
    //     }
    //   }

    private decodeToken(token: string) {
        const tokenParts = token.split('.');
        if (tokenParts.length !== 3) {
            throw new Error('Invalid token format');
        }

        const tokenPayload = JSON.parse(atob(tokenParts[1]));
        return tokenPayload;
    }
    getProfilePictiure() {
        this.userService
            .getProfilePicture(this.user_email)
            .subscribe((response) => {
                this.profile_picture =
                    this.EnvService.userProfile +
                    this.imis_id +
                    '/' +
                    response['profile_picture']['user_profile_picture'];
                const firstname = response['profile_picture']['firstname'];
                const lastname = response['profile_picture']['lastname'];
                this.fullName = `${firstname} ${lastname}`;
            });
        this.rss_url = this.EnvService.rssFeed;
    }



    loadThemeSettings() {
        this.mainBodyService
            .getAllThemeSettings(this.journalId)
            .subscribe((result: responsedata) => {
                if (result.status === 200) {
                    this.themeSettingsData = result.data;
                    this.contactStatus =
                        this.themeSettingsData.contact_us['status'];
                }
            });
    }
    searchClose() {
        this.searchBoxActive = false;
    }

    returnCountryCode(country_language_code: string) {
        const splittedArray = country_language_code.split('-');
        return splittedArray[1]?.toLowerCase();
    }
    changeSiteLanguage(language_code: string): void {
        const splittedArray: string[] = language_code.split('-');
        const countryCode: string = splittedArray[1];
        this.currentCountryCode = countryCode?.toLowerCase();
        this.storageService.setItem('language', language_code);
        this.translateService.use(language_code);
        this.translateService.currentLang = language_code;
        this.userService.languageChange.next('vfdgbh');
    }

    // popupResponcive() {
    //     this.popupResponciveVariable = !this.popupResponciveVariable;
    // }
    // returnJournalLogo(journalSettingData: themeData) {
    //     let url = this.defaultJournalLogo;
    //     if (journalSettingData?.journal_logo) {
    //         url =
    //             this.EnvService.imageUrl +
    //             'themes/' +
    //             this.journalSettingData.journal_logo;
    //     }
    //     return url;
    // }
    returnSocialMedia(journalSettingData: themeData) {

        let links: mediaLink[] = [];
        if (journalSettingData?.social_media_links) {
            // Filter out elements with empty array values
            links = journalSettingData?.social_media_links?.filter(link => link.value !== undefined && link?.value?.length > 0);
        }
        return links;
    }



    removeQuotes(value: string): string {
        return value.replace(/['"]+/g, '');
    }
    processMenuData(result: journalPageResponce) {

        // if (isPlatformBrowser(this.platformId)) {
        //     const language = localStorage.getItem('language');
        //     let languageCode: string = JSON.stringify(language);
        //     languageCode = this.removeQuotes(languageCode);
        //     const menus = result.data[0];
        //     if (result.data.length !== 0) {
        //         const pages = menus.journal_pages;
        //         let pageName = '';
        //         let pageHeading = '';
        //         let pageContent = '';
        //         let menuType='';
        //         this.journalPagesData = [];
        //         pages.forEach((element) => {


        //             if (element.page_name) {
        //                 pageName = element.page_name[languageCode]
        //             }

        //             if (element.page_heading) {
        //                 pageHeading = element.page_heading[languageCode];
        //             }
        //             if (element.page_content) {
        //                 pageContent = element.page_content[languageCode];
        //             }


        //             const Object: journalPagesData = {
        //                 pageHeading: pageHeading,
        //                 pageName: pageName,
        //                 PageContent: pageContent,
        //                 pageId: element.page_name_id,
        //                 status: true,
        //                 published: true,
        //                 sortorder: element.sort_order,
        //                 page_identifier: element.page_identifier,
        //                 menu_type:menuType
        //             };
        //             this.journalPagesData.push(Object);

        //         });

        if (isPlatformBrowser(this.platformId)) {
            const language = localStorage.getItem('language');
            let languageCode: string = JSON.stringify(language);
            languageCode = this.removeQuotes(languageCode);
            const menus = result.data[0];
            if (result.data.length !== 0) {
                const pages = menus.journal_pages;
                let pageName = '';
                let pageHeading = '';
                let pageContent = '';
                let menuType = '';

                this.journalPagesData = [];
                pages.forEach((element) => {

                    if (element.page_name) {
                        pageName = element.page_name[languageCode];
                    }

                    if (element.page_heading) {
                        pageHeading = element.page_heading[languageCode];
                    }
                    if (element.page_content) {
                        pageContent = element.page_content[languageCode];
                    }
                    if (element.menu_type) {
                        menuType = element.menu_type;  // ✅ Now assigning menu_type
                    }

                    const Object: journalPagesData = {
                        pageHeading: pageHeading,
                        pageName: pageName,
                        PageContent: pageContent,
                        pageId: element.page_name_id,
                        status: true,
                        published: true,
                        sortorder: element.sort_order,
                        page_identifier: element.page_identifier,
                        menu_type: menuType  // ✅ Now menu_type has a value
                    };
                    this.journalPagesData.push(Object);

                });
            }



            //const menuNamesToCheck = ['About', 'Access', 'Home'];
            //for JBA
            const menuNamesToCheck = ['Access', 'Home'];
            for (const menuName of menuNamesToCheck) {
                const index = this.journalPagesData.findIndex(
                    (x) => x.pageName === menuName
                );
                if (index !== -1) {
                    // if (menuName === 'About') {
                    //     this.is_exist_about = true;
                    //     this.aboutPageId = this.journalPagesData[index].pageId;
                    // } else
                    if (menuName === 'Access') {
                        this.is_exist_access = true;
                    } else if (menuName === 'Home') {
                        this.is_exist_home_journal = true;
                        this.homePageId = this.journalPagesData[index].pageId;
                    }
                    this.journalPagesData.splice(index, 1);
                }
            }
        }
        this.journalPagesData.sort((a, b) => a.sortorder - b.sortorder);
    }


    getDynamicMenusJournal(jnlid: string) {
        this.loadThemeSettings();
        this.subscription.push(
            this.mainBodyService.getAllDynamicMenus(jnlid).subscribe((result: journalPageResponce) => {
                this.processMenuData(result);

                // const excludedPages = new Set([
                //     'about', 'clustered-themes', 'instructions-for-authors',
                //     'information-for-guest-editors', 'submission-information', 'permissions',
                //     'preparing-your-article', 'references', 'news', 'thematic-collection-proposal-form',
                //     'special-issue-proposal-form', 'influencing-policy-makers',
                //     'production-of-your-article', 'promoting-your-article', 'article-submission'
                // ]);

                if (jnlid === this.publisher_id) {
                    this.dynamic_menus = this.journalPagesData;
                } else {
                    this.dynamic_menus_journal = this.journalPagesData
                        .filter(item => item.menu_type === 'about');
                    // this.dynamic_menus_journal = this.journalPagesData.filter(item => !excludedPages.has(item.page_identifier));

                    // // Insert 'Editorial Board' at index 4 if it exists
                    if (this.dynamic_menus_journal.length > 4) {
                        this.dynamic_menus_journal.splice(4, 0, { pageName: 'Editorial Board', pageId: 'editorialboard' });
                    } else {
                        this.dynamic_menus_journal.push({ pageName: 'Editorial Board', pageId: 'editorialboard' });
                    }
                    this.dynamic_menu_loader = false;
                    this.dynamic_menus_author = this.journalPagesData
                        .filter(item => item.menu_type === 'authors/editors');
                }

            })
        );
    }

    searchArticle() {
        if (isPlatformBrowser(this.platformId)) {
            this.ShowSearchUl = true;
            this.valueForSearch = this.searchForm.get('searchValue')?.value ?? '';
            const term = this.valueForSearch.trim();
            if (term === '') {
                this.searchList = false;
                const dropdownMenu = document.querySelectorAll('.dropdown-menu');
                dropdownMenu.forEach(ulElement => {
                    if (ulElement.role == 'search') {
                        ulElement.classList.remove('show');
                    }
                })
            }
            else {
                const dropdownMenu = document.querySelectorAll('.dropdown-menu');
                dropdownMenu.forEach(ulElement => {
                    if (ulElement.role == 'search') {
                        ulElement.classList.add('show');
                    }
                })
            }
            // Keys/clicks that don't change the value (arrows, shift, refocus) keep the current results.
            if (term === this.searchTerm) {
                return;
            }
            this.searchTerm = term;
            // Drop results of the previous term; "No Data Found" is only shown once the API
            // has answered for this exact term.
            this.noData = false;
            this.searchedArticles = [];
            this.searchLoader = term.length >= this.minSearchLength;
            this.loading = this.searchLoader;
            this.queryParams = {
                search_key: term,
            };
            this.searchSubject.next(term);
        }
    }
    clearSearch() {
        this.searchTerm = null;
        this.searchedArticles = [];
        this.noData = false;
        this.searchLoader = false;
        this.loading = false;
        this.searchForm.get('searchValue')?.setValue('');
    }
    loadArticlePage() {
        this.searchTerm = null;
        this.noData = false;
        this.searchLoader = false;
        this.loading = false;
        this.searchedArticles = [];
        const queryParams = {};
        this.searchForm.get('searchValue')?.setValue('');
        queryParams['search'] = this.valueForSearch;
        this.articleService.urlChange = true;
        this.router.navigate(['articles/page/1'], { queryParams });
    }
    toFetchJournalMenuData(journal_id: string) {
        const dynamicMenuSub = this.mainBodyService
            .getAllDynamicMenus(journal_id)
            .subscribe((result: journalPageResponce) => {
                if (result.status === 200) {
                    this.journalDynamicData = [];
                    this.processMenuData(result);
                    this.journalDynamicData = this.journalPagesData;
                }
            });
        this.subscription.push(dynamicMenuSub);
        const volumeSub = this.volumeService
            .getVolumeIssues(journal_id)
            .subscribe((result) => {
                this.volumeData = result.data;
            });
        this.subscription.push(volumeSub);

        const queryParams: listAllarticle = {
            length: 3,
            start: 0,
            search_key: '',
            search_filters: '',
            search_keywords: '',
            sort_by: '',
            volume_id: '',
            issue_id: '',
            special_issue: false,
            thematic_id: ''
            // favourites_data:[],
            // journal_id:''
        };
        const getAllArticleSub = this.articleService
            .getArticles(queryParams, journal_id)
            .subscribe((result) => {
                this.articleList = result.data;

            });
        const queryParam: listAllarticle = {
            length: 3,
            start: 0,
            search_key: '',
            search_filters: 'fasttrack',
            search_keywords: '',
            sort_by: '',
            volume_id: '',
            issue_id: '',
            special_issue: false,
            thematic_id: ''
            // favourites_data:[],
            // journal_id:''
        };
        this.articleService
            .getArticles(queryParam, journal_id)
            .subscribe((result) => {
                this.fastTrackList = result.data;
            });
        this.subscription.push(getAllArticleSub);
    }

    userLogout() {
        this.storageService.removeItem('loggedInUsername');
        this.storageService.removeItem('BEARER_TOKEN');
        this.loggedInUsername = '';
        this.islogined = false;
    }

    openLoginModal() {
        const modalRef = this.modalService.open(LoginComponent);
        modalRef.componentInstance.name = 'Rv-host'; //World
    }

    openProfile() {
        this.router.navigate(['user/user-profile']);
    }

    ngOnDestroy() {
        this.subscription.forEach((x) => {
            if (!x.closed) {
                x.unsubscribe();
            }
        });
    }

    @HostListener('window:scroll', ['$event'])
    onWindowScroll(event: any) {
        if (isPlatformBrowser(this.platformId)) {
            // const scrollPosition =
            //     window.pageYOffset ||
            //     document.documentElement.scrollTop ||
            //     document.body.scrollTop ||
            //     0;
            // const scrollpos = 100;
            // const element = document.querySelector('.search-dropdown') as HTMLElement;

            //to show or hide scrolltotop button
            // if (scrollPosition >= scrollpos) {
            //     this.hideNavOnScroll.nativeElement.classList.add('hide-nav');
            // } else {
            //     this.hideNavOnScroll.nativeElement.classList.remove('hide-nav');
            // }

            this.isSmallScreen = event.target.innerWidth < 992;

        }

    }
    @HostListener('window:resize', ['$event'])
    onResize(event: any) {
        this.isSmallScreen = event.target.innerWidth < 992;

    }



    openDropdown(menuType: string) {
        if (isPlatformBrowser(this.platformId)) {
            // if (this.dynamic_menus_journal.length === 0)
            // this.getDynamicMenusJournal(this.journal_id_jba);
            const parentElement = document.querySelector(`.dropdown-${menuType}`);

            if (parentElement && this.searchForm.controls['searchValue'].value.length > 2) {
                const dropdownMenu = parentElement?.querySelector('.dropdown-menu');
                if (dropdownMenu) {
                    dropdownMenu.classList.add('show');
                }
            }
        }
    }

    closeDropdown(menuType: string) {
        if (isPlatformBrowser(this.platformId)) {
            const parentElement = document.querySelector(`.dropdown-${menuType}`);
            if (parentElement) {
                const dropdownMenu = parentElement.querySelector('.dropdown-menu');
                if (dropdownMenu) {
                    dropdownMenu.classList.remove('show');
                }
            }
        }
    }
    ensureHttps(url: string): string {
        if (url) {
            if (!url.startsWith('http://') && !url.startsWith('https://')) {
                return 'https://' + url;
            }
            return url;
        }
        return url;
    }
    ngAfterViewInit(): void {
        if (isPlatformBrowser(this.platformId)) {
            this.rss_url = this.EnvService.rssFeed;
            // this.getDynamicMenusJournal(this.journal_id_jba);
            setTimeout(() => {
                if (isPlatformBrowser(this.platformId)) this.isSmallScreen = window.innerWidth < 992;
            }, 1000);
        }
    }

    specialIssueArticles() {
        const queryParams = {};
        queryParams['special_issue'] = true;
        this.articleService.urlChange = true;
        this.router.navigate(['articles/page/1'], { queryParams });
    }
    getOffcanvas() {
        if (isPlatformBrowser(this.platformId)) {
            const element = document.getElementsByClassName('offcanvas-backdrop fade show');
            if (element)
                Array.from(element).forEach(elements => {
                    // Add a click event listener
                    elements.addEventListener('click', this.clickFound.bind(this));
                });
            this.isSmallScreen = window.innerWidth < 992;
            this.openDropdown('about');
            this.openDropdown('articles');
            this.openDropdown('SubmitArticles');
        }
    }
    clickFound() {
        if (isPlatformBrowser(this.platformId)) {
            const element = document.getElementsByClassName('offcanvas-backdrop fade show');
            if (element) {
                Array.from(element).forEach(elements => {
                    elements.remove()
                })
            }
        }
    }
    showSearchBar() {
        this.showSearchBarTextBox = !this.showSearchBarTextBox;
    }
    closeCanvas(): void {
        if (isPlatformBrowser(this.platformId)) {
            const offcanvasElement = document.getElementsByClassName('offcanvas offcanvas-end show');
            if (offcanvasElement) {
                Array.from(offcanvasElement).forEach(elements => {
                    // Add a click event listener
                    elements.addEventListener('click', () => {
                        elements.classList.remove('offcanvas-end show')
                    });
                });
            }
        }
    }

    skipToMain() {
        if (isPlatformBrowser(this.platformId)) {
            const element = document.querySelector('[role="main"]') as HTMLElement;
            element.setAttribute('tabindex', '-1') // You can set tabindex in HTML too than in JS
            element.focus()
        }
    }

}
